/**
 * Booking-site visual themes. Every theme renders the same components and sections; a theme only swaps
 * the design tokens in public-site.css (`.ps[data-theme="..."]`). Free themes are open to every plan;
 * premium themes need the PREMIUM_THEMES plan feature.
 */
export const BOOKING_SITE_THEMES = [
  { id: "classic", tier: "free" },
  { id: "minimal", tier: "free" },
  { id: "elegant", tier: "premium" },
  { id: "coastal", tier: "premium" },
  { id: "sunset", tier: "premium" },
  { id: "palatin", tier: "premium" },
  { id: "eco", tier: "premium" },
] as const;

export type BookingSiteThemeId = (typeof BOOKING_SITE_THEMES)[number]["id"];

export const DEFAULT_THEME: BookingSiteThemeId = "classic";

export function isThemeId(value: unknown): value is BookingSiteThemeId {
  return BOOKING_SITE_THEMES.some((t) => t.id === value);
}

export function isPremiumTheme(id: BookingSiteThemeId): boolean {
  return BOOKING_SITE_THEMES.some((t) => t.id === id && t.tier === "premium");
}

/** Reads the chosen theme out of theme_settings (unknown ids fall back to the default). */
export function themeFromSettings(settings: Record<string, unknown> | null | undefined): BookingSiteThemeId {
  const id = settings?.theme;
  return isThemeId(id) ? id : DEFAULT_THEME;
}
